// extracted by mini-css-extract-plugin
export default {"modalbox":"ConfirmPasswordResetModal_modalbox__S3vzM"};